(function () {
  var namespace = 'TCEHomeTitleMotionV1';
  var groupSelector = [
    '.tce-home__hero-copy',
    '.tce-home__collection-head',
    '.tce-home__best-head',
    '.tce-home__diy-copy',
    '.tce-home__process-head',
    '.tce-home__reviews-head',
    '.tce-home__bead-head'
  ].join(',');

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  var states = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function findHomes(root) {
    var homes = [];

    if (root instanceof Element && root.matches('[data-tce-home]')) {
      homes.push(root);
    }
    if (root.querySelectorAll) {
      homes = homes.concat(Array.from(root.querySelectorAll('[data-tce-home]')));
    }

    return homes;
  }

  function getGroupLines(group) {
    return Array.from(group.children).filter(function (line) {
      return line.matches('p, h1, h2, span');
    });
  }

  function animateGroup(group) {
    var lines = getGroupLines(group);
    lines.forEach(function (line) {
      line.classList.add('tce-title-pop-active');
      line.addEventListener('animationend', function () {
        line.classList.add('tce-title-pop-complete');
      }, { once: true });
    });
    group.dataset.tceTitleRevealed = 'true';
  }

  function initializeHome(home) {
    if (states.has(home)) return;

    var groups = Array.from(home.querySelectorAll(groupSelector));
    if (!groups.length) return;

    var observer = null;
    var lineCount = 0;
    groups.forEach(function (group, index) {
      var lines = getGroupLines(group);
      group.dataset.tceTitleMotionGroup = String(index + 1);
      lineCount += lines.length;
      lines.forEach(function (line) {
        line.dataset.tceTitleMotionLine = String(index + 1);
      });
    });

    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target.dataset.tceTitleRevealed !== 'true') {
            animateGroup(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: mobile ? '0px 0px -14% 0px' : '0px 0px -8% 0px',
        threshold: mobile ? 0.35 : 0.2
      });

      groups.forEach(function (group) {
        observer.observe(group);
      });
    }

    home.dataset.tceTitleMotionCount = String(groups.length);
    home.dataset.tceTitleMotionLineCount = String(lineCount);
    states.set(home, { groups: groups, observer: observer });
  }

  function init(root) {
    findHomes(root || document).forEach(initializeHome);
  }

  function destroy(root) {
    findHomes(root || document).forEach(function (home) {
      var state = states.get(home);
      if (!state) return;

      if (state.observer) state.observer.disconnect();
      state.groups.forEach(function (group) {
        delete group.dataset.tceTitleMotionGroup;
        getGroupLines(group).forEach(function (line) {
          line.classList.remove('tce-title-pop-active');
          line.classList.remove('tce-title-pop-complete');
          delete line.dataset.tceTitleMotionLine;
        });
        delete group.dataset.tceTitleRevealed;
      });
      delete home.dataset.tceTitleMotionCount;
      delete home.dataset.tceTitleMotionLineCount;
      states.delete(home);
    });
  }

  window[namespace] = { init: init, destroy: destroy };
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
